import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initDevLogger } from './utils/logger.dev.ts';
import { initSentry } from './utils/sentryUtils.ts';

initDevLogger();
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
